import $ from "jquery";

const componentSelector = ".component-back-top";
const visibleThreshold = 200;


class BackTop {

    constructor() {
        this.isVisible = false;
    }

    scroll(topDistance) {
        if(this.isVisible && topDistance < visibleThreshold) {
            this.hide();

            return;
        }

        if(this.isVisible === false && topDistance >= visibleThreshold) {
            this.show();

            return;
        }
    }

    show() {
        $(componentSelector).addClass("visible");
        this.isVisible = true;
    }

    hide() {
        $(componentSelector).removeClass("visible");
        this.isVisible = false;
    }

}

export default function() {
    if ($(componentSelector).length <= 0) {
        return;
    }

    const component = new BackTop();

    $(document).scroll(function() {
        component.scroll($(document).scrollTop());
    });
}